import { withI18n } from 'react-i18next';
import TrackingTable from './TrackingTable';

export const pureComponent = TrackingTable;
export default withI18n()(TrackingTable);
